class YouTubePlayer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.dataset.videoId) return

    this.createPlayerIframe()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })

    this.externalEls?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.handleClose()
      }
    })
  }

  createPlayerIframe (options = {}) {
    if (!this.dataset.videoId) return

    const {
      autoplay = false,
      controls = 1,
      rel = 0,
      modestbranding = 1,
      playsinline = 1,
    } = options

    if (!this.iframeEl) {
      const iframe = document.createElement('iframe')
      iframe.setAttribute('allowfullscreen', '')
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
      )
      iframe.setAttribute('frameborder', '0')
      iframe.classList.add('app-Youtube')

      this.innerHTML = ''
      this.appendChild(iframe)
      this.iframeEl = iframe
    }

    const params = new URLSearchParams({
      autoplay: autoplay ? '1' : '0',
      controls: String(controls),
      rel: String(rel),
      modestbranding: String(modestbranding),
      playsinline: String(playsinline),
      enablejsapi: '1',
      origin: window.location.origin,
    })

    const embedUrl = `https://www.youtube.com/embed/${encodeURIComponent(
      this.dataset.videoId,
    )}?${params.toString()}`

    this.iframeEl.src = embedUrl
  }

  handleTrigger () {
    this.createPlayerIframe({ autoplay: true })

    if (this.iframeEl && this.iframeEl.contentWindow) {
      this.iframeEl.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: [],
        }),
        '*',
      )
    }
  }

  handleClose () {
    if (this.iframeEl && this.iframeEl.contentWindow) {
      this.iframeEl.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: [],
        }),
        '*',
      )
    }
  }
}

if (!customElements.get('youtube-player')) {
  customElements.define('youtube-player', YouTubePlayer)
}
